/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Organize_4Inputs */

const en_pc_tut_organize_4 = /** @type {(inputs: Pc_Tut_Organize_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move pages earlier or later. Made a mistake? ⌘Z undoes it, even after you save.`)
};

const zh_pc_tut_organize_4 = /** @type {(inputs: Pc_Tut_Organize_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将页面前移或后移。操作失误？⌘Z 即可撤销，保存后依然有效。`)
};

/**
* | output |
* | --- |
* | "Move pages earlier or later. Made a mistake? ⌘Z undoes it, even after you save." |
*
* @param {Pc_Tut_Organize_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_organize_4 = /** @type {((inputs?: Pc_Tut_Organize_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Organize_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_organize_4(inputs)
	return zh_pc_tut_organize_4(inputs)
});
export { pc_tut_organize_4 as "pc.tut.organize.4" }